import "styles/taxCalc.less";

import { UK_ROUTES_NEW } from "constants/routes-new";

import React, { useContext, useState } from "react";

import { Typography } from "antd";
import { AppContext } from "App";
import Layout from "components/basic/Layout";
import SignUpSection from "components/common/SignUpSection";

import CalculatorTabSwitch from "./components/CalculatorTabSwitch";
import DetailSubmission from "./components/DetailSubmission";
import ResultsWindow from "./components/ResultsWindow";
import Navigation from "../../basic/Navigation/Navigation";

const EmploymentTaxCalc: React.FC = () => {
    const { isMobile } = useContext(AppContext);
    const [ showResults, setShowResults ] = useState<boolean>(false);
    return (
        <Layout>
            <Navigation items={[{
                title: "Home",
                url: UK_ROUTES_NEW.home,
            }, {
                title: "Tax Calculator",
                url: UK_ROUTES_NEW.employmentTaxCalc,
            }]} />
            <div className={isMobile ? "tax-calc__page-container-mobile" : "tax-calc__page-container-desktop"}>
                <div className={isMobile ? "tax-calc__header_mobile" : "tax-calc__header_desktop"}>
                    <Typography className={isMobile ? "tax-calc__title_mobile" : "tax-calc__title_desktop"}>
                        Tax Calculator
                    </Typography>
                    <Typography className="tax-calc__text">
                        Use Taxzap's Tax Calculator to get an instant estimate of your tax bill or potential refund.
                    </Typography>
                </div>
                <CalculatorTabSwitch />
                <div style={isMobile ? {} : { display: "flex", alignItems: "flex-start" }}>
                    <DetailSubmission
                        setShowResults={setShowResults}
                    />
                    {(!isMobile || showResults) && <ResultsWindow />}
                </div>
            </div>
            <SignUpSection />
        </Layout>
    );
};

export default EmploymentTaxCalc;
